export default function (...args)
{
	return {
		regex: /^(\d{8,13})$/,
		filter: /[-.]/g,
		store_mask: '$1',
		display_mask: '$1'
	};
}

